import {get} from 'app/utils/axios/kheti'
import {Crop} from '../models/crop'

const fetchFarmerCrops = async (farmerId: string) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/crops`
    const res =  await get<Crop[]>(url)
    return Object.entries(res)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as Crop[];
  } catch (e) {
    return []
  }
}

export default fetchFarmerCrops
